import styled from 'styled-components';

export const StyledUserPanelAdditions = styled.div`
    width: 100%;
    height: 100%;
`;
